export class SupplierSchedule {
    constructor(
        public readonly id: string,
        public readonly rang: number,
        public readonly code: string,
        public readonly name: string,
        public readonly schedule: string,
        public readonly isOrderDay: boolean,
        public readonly moa: number,
        public readonly moq: number,
        public readonly orderScheduleID: number) {
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/suppliers-schedules/supplier-schedule.ts